import React, { useEffect } from "react";
import { motion } from "framer-motion";
import Header from "../../components/header/Header";
import HeaderSeo from "../../components/head-seo/HeaderSeo";
import Banner from "../../components/banner/Banner";
import ServicePageCard from "../../components/servicepage-card/ServicePageCard";
import ContactInfo from "../../components/contact-info/ContactInfo";
import Footer from "../../components/footer/Footer";
import { ServiceBanner } from "../../utils/Banner";
import { ServiceSeo } from "../../utils/Seo";
import "./servicepage.css";
import OurService from "../../components/our-service/OurService";

const ServicePage = () => {
  useEffect(() => {
    window.scroll({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 1 } }}>
      <HeaderSeo data={ServiceSeo} />
      <Header />
      <div className="tex_wrap"><Banner data={ServiceBanner} /></div>
      <OurService marginTopRemove={true} />
      <ServicePageCard/> 
      {/* <ContactInfo /> */}
      <Footer />
    </motion.div>
  );
};

export default ServicePage;
